/* global window */
import mimeTypes from '../utils/mimeTypes'

import apiSystem from './apiSystem'

const FileServices = {
  async upload(file, type) {
    const data = new FormData()
    data.append('file', file)
    const res = await apiSystem.post(`/file/upload?type=${type}`, data)
    if (res.ok) {
      return res.data
    }
    throw new Error(res)
  },
  async download(fileName) {
    const res = await apiSystem.get(`/file/download?fileName=${fileName}`, {}, {
      responseType: 'blob',
    })
    if (!res.ok) {
      return null
    }
    const img = window.URL.createObjectURL(res.data)
    return img
  },
  async downloadAsBlob(fileName) {
    const res = await apiSystem.get(`/file/download?fileName=${fileName}`, {}, {
      responseType: 'blob',
    })
    if (!res.ok) {
      return null
    }
    return res.data
  },
  async downloadFile(fileName) {
    const idx = fileName.lastIndexOf('/')
    const file = fileName.slice(idx + 1, fileName.length)
    const fileTypeIdx = file.lastIndexOf('.')
    const fileType = file.slice(fileTypeIdx + 1, file.length)
    const mimeType = mimeTypes[fileType]
    const res = await apiSystem.get(`/file/download?fileName=${fileName}`, {}, {
      responseType: 'blob',
    })
    if (!res.ok) {
      return null
    }
    const newFile = new File([res.data], file, {
      type: mimeType,
    })
    const f = window.URL.createObjectURL(newFile)
    return f
  },
}

export default FileServices
